module.exports = __webpack_public_path__ + "img/gift-13-c1.9f37c450.png";